import {
    GET_ALL_DAILY_COLLECTIONS_REQUEST,
    GET_ALL_DAILY_COLLECTIONS_SUCCESS,
    GET_ALL_DAILY_COLLECTIONS_FAIL,
    GET_ALL_DAILY_COLLECTIONS_RESET,
    GET_DAILY_RECOVERY_COLLECTIONS_REQUEST,
    GET_DAILY_RECOVERY_COLLECTIONS_SUCCESS,
    GET_DAILY_RECOVERY_COLLECTIONS_FAIL,
    GET_DAILY_RECOVERY_COLLECTIONS_RESET,
    GET_DAILY_FLOW_COLLECTIONS_REQUEST,
    GET_DAILY_FLOW_COLLECTIONS_SUCCESS,
    GET_DAILY_FLOW_COLLECTIONS_FAIL,
    GET_DAILY_FLOW_COLLECTIONS_RESET,
   } from '../constants/dailyMisConstants'
   
   export const getAllDailyCollectionsReducer = (state = {}, action) => {
    switch (action.type) {
      case GET_ALL_DAILY_COLLECTIONS_REQUEST:
        return { loadingAllDailyCollections: true }
      case GET_ALL_DAILY_COLLECTIONS_SUCCESS:
        return {
          loadingAllDailyCollections: false,
          allDailyCollectionsData: action.payload,
        }
      case GET_ALL_DAILY_COLLECTIONS_FAIL:
        return {
          loadingAllDailyCollections: false,
          errorAllDailyCollections: action.payload,
        }
      case GET_ALL_DAILY_COLLECTIONS_RESET:
        return {}
      default:
        return state
    }
   }
   
   export const getDailyRecoveryCollectionsReducer = (state = {}, action) => {
    switch (action.type) {
      case GET_DAILY_RECOVERY_COLLECTIONS_REQUEST:
        return { loadingDailyRecoveryCollections: true }
      case GET_DAILY_RECOVERY_COLLECTIONS_SUCCESS:
        return {
          loadingDailyRecoveryCollections: false,
          dailyRecoveryCollectionsData: action.payload,
        }
      case GET_DAILY_RECOVERY_COLLECTIONS_FAIL:
        return {
          loadingDailyRecoveryCollections: false,
          errorDailyRecoveryCollections: action.payload,
        }
      case GET_DAILY_RECOVERY_COLLECTIONS_RESET:
        return {}
      default:
        return state
    }
   }
   
   export const getDailyFlowCollectionsReducer = (state = {}, action) => {
    switch (action.type) {
      case GET_DAILY_FLOW_COLLECTIONS_REQUEST:
        return { loadingDailyFlowCollections: true }
      case GET_DAILY_FLOW_COLLECTIONS_SUCCESS:
        return {
          loadingDailyFlowCollections: false,
          dailyFlowCollectionsData: action.payload,
        }
      case GET_DAILY_FLOW_COLLECTIONS_FAIL:
        return {
          loadingDailyFlowCollections: false,
          errorDailyFlowCollections: action.payload,
        }
      case GET_DAILY_FLOW_COLLECTIONS_RESET:
        return {}
      default:
        return state
    }
   }